<template>
  <!-- dashboard-content-area-start -->
  <div class="tpd-content-layout">
    <!-- dashboard-tab-area -->
    <div class="dashboader-area mb-25">
      <div class="tp-dashboard-tab">
        <div class="d-flex align-items-center">
          <h2 class="tp-dashboard-tab-title border-0 m-0"> {{ lms_website.__('Certificates') }} </h2>
          <div class="ms-auto me-3">
            <button type="button" @click="openCertificates" class="btn btn-sm btn-dark">{{ lms_website.__('Get Certificates') }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- dashboard-tab-area-end -->
    <div class="tpd-table mb-25">
      <ul>
        <li class="tpd-table-head">
          <div class="tpd-table-row">
            <div class="tpd-order-id" style="width:100%">
              <h4 class="tpd-table-title">{{ lms_website.__('Course') }}</h4>
            </div>
          </div>
        </li>
        <template v-if="certificates.loading">
          <li>
            <div class="placeholder-glow">
              <div class="d-flex gap-3">
                <span class="placeholder d-block rounded" style="width:100%;height:30px;"></span>
                <span class="placeholder d-block rounded" style="width:100%;height:30px;"></span>
              </div>
            </div>
          </li>
        </template>
        <template v-if="!activeCertificates?.length && !certificates.loading">
          <li>
            <div class="pe-3 ps-3">
              <div class="alert alert-warning w-100">
                <i class="far fa-info-circle mr-1"></i> {{ lms_website.__('Not Certificates Found') }}
              </div>
            </div>
          </li>
        </template>
        <template v-if="activeCertificates?.length && !certificates.loading">
          <li v-for="certificate in paginatedCertificates" :key="certificate.name">
            <div class="tpd-table-row">
              <div class="tpd-order-name d-flex align-items-center" style="width:calc(100% - 40px)">
                <div class="d-flex align-items-center gap-3">
                  <img src="/assets/lms_website/images/certificate_icon.jpg" style="width:100px;border-radius:10px;" alt="">
                  <div>
                    <h4 class="tpd-common-text mb-1"> {{ certificate.course?.title }} </h4>
                    <div class="d-flex me-2 align-items-center gap-2 mt-3">
                      <span class="badge text-bg-primary font-w-600" v-if="certificate.course?.custom_final_quiz">{{ lms_website.__('Final Quiz') }}</span>
                      <span class="badge text-bg-dark font-w-600" v-if="!certificate.course?.custom_final_quiz">{{ lms_website.__('Course') }}</span>
                      <span class="badge text-bg-secondary font-w-600">{{ lms_website.__('Issue Date') }} :  {{ (certificate.issue_date) ? moment(certificate.issue_date).format('MMM DD, YYYY') : '' }}</span>
                      <span class="badge text-bg-secondary font-w-600">{{ lms_website.__('Expiry Date') }} :  {{ (certificate.expiry_date) ? moment(certificate.expiry_date).format('MMM DD, YYYY') : '' }}</span>
                    </div>
                  </div>
                </div>
                <div class="d-flex gap-2 ms-auto align-items-center">
                  <button class="tpd-certificate-badge active w-auto" @click="previewCertificate(certificate)">
                    <span class="tpd-certificate-badge-text">
                       <span class="tpd-certificate-badge-file">
                          <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                             <path
                                 d="M13.4851 4.007C11.8669 1.4641 9.49912 0 7.00525 0C5.75832 0 4.54641 0.364273 3.43958 1.04378C2.33275 1.7303 1.338 2.73205 0.525394 4.007C-0.175131 5.10683 -0.175131 6.89317 0.525394 7.99299C2.14361 10.5429 4.51138 12 7.00525 12C8.25219 12 9.4641 11.6357 10.5709 10.9562C11.6778 10.2697 12.6725 9.26795 13.4851 7.99299C14.1856 6.90018 14.1856 5.10683 13.4851 4.007ZM7.00525 8.83363C5.43608 8.83363 4.17513 7.56567 4.17513 6.0035C4.17513 4.44133 5.43608 3.17338 7.00525 3.17338C8.57443 3.17338 9.83538 4.44133 9.83538 6.0035C9.83538 7.56567 8.57443 8.83363 7.00525 8.83363Z"
                                 fill="#24A148"></path>
                             <path opacity="0.4" d="M7.00431 3.99976C5.90449 3.99976 5.00781 4.89643 5.00781 6.00326C5.00781 7.10308 5.90449 7.99976 7.00431 7.99976C8.10413 7.99976 9.00781 7.10308 9.00781 6.00326C9.00781 4.90343 8.10413 3.99976 7.00431 3.99976Z" fill="#24A148"></path>
                          </svg>
                       </span>
                      {{ lms_website.__('Preview') }}
                    </span>
                  </button>
                  <div class="tpd-action-btn">
                    <a :href="`/api/method/frappe.utils.print_format.download_pdf?doctype=LMS Certificate&name=${certificate.name}&format=${certificate.template}&no_letterhead=1&letterhead=No%20Letterhead&settings=%7B%7D&_lang=en`" target="_blank" :download="certificate.name">
                      <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 8.23975V10.7466C13 11.079 12.8595 11.3979 12.6095 11.6329C12.3594 11.868 12.0203 12.0001 11.6667 12.0001H2.33333C1.97971 12.0001 1.64057 11.868 1.39052 11.6329C1.14048 11.3979 1 11.079 1 10.7466V8.23975" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M10.3327 5.38704L6.99935 8.52063L3.66602 5.38704" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M7 1V8.52061" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span class="tpd-action-tooltip">{{ lms_website.__('Download') }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </div>
    <Pagination
        v-if="!certificates.loading"
        :current-page="certificates.currentPage"
        :total-items="activeCertificates?.length"
        :items-per-page="certificates.itemsPerPage"
        @page-changed="handlePageChange"
    />
  </div>
  <teleport to="body">
    <div class="modal fade" id="certificateModal" tabindex="-1" aria-labelledby="certificateModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="certificateModalLabel">{{ lms_website.__('Create Certificate') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" :class="{'form-loading':(create_certificate_loading || courses.loading)}">
            <ul class="list-group">
              <template v-if="courses.list?.length">
                <li class="list-group-item" v-for="course in courses.list" :key="course.name">
                  <div class="d-flex align-items-center" style="column-gap:10px">
                    <img style="width:60px;height:55px;border-radius:10px;" :src="(course.image)?course.image:'/assets/lms_website/images/placeholder.jpg'" alt="">
                    <div>
                      <h6 class="mb-1">{{ course.title }}</h6>
                      <span class="badge text-bg-primary font-w-600" v-if="course.custom_final_quiz">{{ lms_website.__('Final Quiz') }}</span>
                      <span class="badge text-bg-dark font-w-600" v-if="!course.custom_final_quiz">{{ lms_website.__('Course') }}</span>
                    </div>
                    <button type="button" @click="createCertificate(course)" :disabled="create_certificate_loading" class="btn btn-sm btn-primary ms-auto">
                      {{ lms_website.__('Create Certificate') }}
                    </button>
                  </div>
                </li>
              </template>
              <template v-else>
                <li class="list-group-item">
                  <div class="alert alert-warning m-0">
                    <i class="far fa-info-circle mr-1"></i> {{ lms_website.__('No Courses Found') }}
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="certificateViewModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="certificateViewModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable" :class="{'modal-fullscreen':(certificateModal.full_screen),'modal-xl':(!certificateModal.full_screen)}">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="certificateViewModalLabel">{{ certificateModal.certificate?.course?.title }}</h1>
            <div class="ms-auto">
              <button type="button" class="btn btn-full-screen" @click="certificateModal.full_screen=!certificateModal.full_screen">
                <i v-if="!certificateModal.full_screen" class="far fa-expand"></i>
                <i v-if="certificateModal.full_screen" class="far fa-compress"></i>
              </button>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning" v-if="!certificateModal.certificate?.template">{{ lms_website.__('Template name not found') }}</div>
            <div class="pdf-viewer" :class="(!certificateModal.file_loaded)?'is-loading':''">
              <div id="PDFViewer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import {authData, isLoggedIn} from "../../../utils/auth";
import Pagination from "../../../components/Pagination.vue";

export default {
  name: "Certificate",
  components: {Pagination},
  props: {},
  setup() {
    return {
      isLoggedIn,
      lms_website,
      moment
    }
  },
  data() {
    return {
      authData: authData(),
      create_certificate_loading: false,
      certificates: {
        loading: true,
        currentPage: 1,
        itemsPerPage: 5,
        list: [],
      },
      certificateModal: {
        full_screen: false,
        file_loaded: false,
        certificate: {}
      },
      courses: {
        list: [],
        loading: true
      },
    }
  },
  computed: {
    auth() {
      if (this.authData && this.authData.is_logged_in && this.authData.user) {
        return this.authData;
      }
    },
    activeCertificates() {
      return this.certificates.list;
    },
    paginatedCertificates() {
      const start = (this.certificates.currentPage - 1) * this.certificates.itemsPerPage;
      const end = start + this.certificates.itemsPerPage;
      return this.activeCertificates.slice(start, end);
    },
  },
  watch: {},
  methods: {
    get_user_certificates() {
      this.certificates.loading = true;
      frappe.call({
        type: "GET",
        method: "lms_website.api.user.get_user_certificates",
        args: {},
        callback: ({message}) => {
          this.certificates.loading = false;
          this.certificates.list = message;
        },
      });
    },
    format_currency(price = 0, currency = '') {
      return format_currency(price, currency);
    },
    handlePageChange(page) {
      this.certificates.currentPage = page;
    },
    get_certificates_courses() {
      this.courses.loading = true;
      frappe.call({
        type: "GET",
        method: "lms_website.api.user.get_certificates_courses",
        args: {},
        callback: ({message}) => {
          this.courses.loading = false;
          this.courses.list = message;
          console.log('get_certificates_courses', message)
        },
      });
    },
    openCertificates() {
      $('#certificateModal').modal('show');
    },
    createCertificate(course) {
      this.create_certificate_loading = true;
      frappe.call({
        type: "POST",
        method: "lms_website.api.courses.create_certificate",
        args: {
          course: course.name
        },
        callback: ({message}) => {
          console.log('create_certificate', message)
          this.create_certificate_loading = false;
          $('#certificateModal').modal('hide');
          this.get_user_certificates();
        },
      })
    },
    previewCertificate(certificate) {
      this.certificateModal.file_loaded = false;
      this.certificateModal.certificate = certificate;
      console.log('certificate', certificate)
      const PDFViewer = $('#PDFViewer');
      $('#certificateViewModal').modal('show');
      PDFViewer.html('');
      setTimeout(() => {
        if ($('#PDFViewer').length)
          $.when(
              $.getScript("https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.2.2/pdf.js"),
              $.getScript("https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.2.2/pdf.worker.js")
          ).done(() => {
            window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.2.2/pdf.worker.js';
          }).then(() => {
            $('#PDFViewer').kendoPDFViewer({
              pdfjsProcessing: {
                file: `${lms_website.get_base_url()}/api/method/frappe.utils.print_format.download_pdf?doctype=LMS Certificate&name=${certificate.name}&format=${certificate.template}&no_letterhead=1&letterhead=No%20Letterhead&settings=%7B%7D&_lang=en`
              },
              width: "100%",
              height: window.innerHeight - 160
            });
            this.certificateModal.file_loaded = true;
          })
      }, 2000);

    },
    getPDFLink(pdf_link) {
      if (this.isValidUrl(pdf_link)) {
        return pdf_link;
      } else {
        return lms_website.get_base_url() + pdf_link;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      NProgress.done();
      this.get_user_certificates();
      this.get_certificates_courses();
      $("[data-background]").each(function () {
        $(this).css("background-image", "url( " + $(this).attr("data-background") + "  )");
      });
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
.pdf-viewer {
  background: #eeeeee;
  min-height: calc(100vh - 180px);
  border-radius: 10px;

  &.is-loading {
    position: relative;

    iframe {
      opacity: 0;
    }

    &:before {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 20;
      content: "";
    }

    &:after {
      box-shadow: 0 0 45px rgba(0, 0, 0, 0.45);
      border: 4px solid #b9bac4;
      border-top: 4px solid var(--bs-primary);
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: block;
      animation: loader-spin 0.5s linear infinite;
      -webkit-animation: loader-spin 0.5s linear infinite;
      -moz-animation: loader-spin 0.5s linear infinite;
      -o-animation: loader-spin 0.5s linear infinite;
      -ms-animation: loader-spin 0.5s linear infinite;
      position: absolute;
      z-index: 55;
      left: 50%;
      top: 50%;
      margin-top: -20px;
      margin-left: -20px;
      content: "";
    }
  }
}

.youtube-iframe, .custom-iframe {
  min-height: calc(100vh - 180px);
}

.modal-fullscreen {
  .pdf-viewer {
    min-height: calc(100vh - 50px);
  }

  .youtube-iframe, .custom-iframe {
    min-height: calc(100vh - 110px);
  }
}
</style>
